const PENDING_CLAIM_STORAGE_KEY = 'quickpass:pending-claim-path'

/**
 * Stashes the claim deep-link path so it survives the sign-in redirect. A
 * signed-out renter who opens a claim link is sent to sign-in; the public-only
 * route guard reads this back and returns them to the claim page afterwards.
 *
 * @param {string} path - the full claim path including the token query (e.g. /claim-tenancy?token=abc)
 * @returns {void}
 */
const setPendingClaimPath = (path: string): void => {
  try {
    window.localStorage.setItem(PENDING_CLAIM_STORAGE_KEY, path)
  } catch (error) {
    console.warn('[pending-claim] failed to store pending claim path', error)
  }
}

/**
 * Reads the stashed claim path, or null when none is pending.
 *
 * @returns {string | null}
 */
const readPendingClaimPath = (): string | null => {
  try {
    return window.localStorage.getItem(PENDING_CLAIM_STORAGE_KEY)
  } catch (error) {
    console.warn('[pending-claim] failed to read pending claim path', error)
    return null
  }
}

/**
 * Clears any stashed claim path. Called once the renter reaches the claim page.
 *
 * @returns {void}
 */
const clearPendingClaimPath = (): void => {
  try {
    window.localStorage.removeItem(PENDING_CLAIM_STORAGE_KEY)
  } catch (error) {
    console.warn('[pending-claim] failed to clear pending claim path', error)
  }
}

export { setPendingClaimPath, readPendingClaimPath, clearPendingClaimPath }
